<template>
  <svg version="1.1" :width="width" :height="height" viewBox="0 0 24 24">
    <path
      :fill="color"
      d="m 10,20.2 h 4 c 0,1.1 -0.9,2 -2,2 -1.1,0 -2,-0.9 -2,-2 M 21,19 v 0.9 H 3 V 19 L 5,17 V 11 C 5,7.9 7,5.2 10,4.3 V 4 c 0,-1.1 0.9,-2 2,-2 1.1,0 2,0.9 2,2 v 0.3 c 3,0.9 5,3.6 5,6.7 v 6 l 2,2 M 17.8,11 C 17.8,8.2 15.942801,5.0797051 12,5.1 7.8929886,5.1211401 6.2,8.2 6.2,11 v 6 l -2,2 h 15.6 l -2,-2 z"
    />
  </svg>
</template>

<script>
// @group Icons
// Bell icon
export default {
  name: "NotificationsIcon",
  props: {
    /** width in pixels */
    width: {
      type: Number,
      default: 24
    },
    /** height in pixels */
    height: {
      type: Number,
      default: 24
    },
    /** foreground color */
    color: {
      type: String,
      default: "white"
    }
  }
};
</script>
